import { Slice } from '@atlaskit/editor-prosemirror/model';
import { safeInsert } from '@atlaskit/editor-prosemirror/utils';
import { addAnalytics } from '../../analytics/utils';
import { messages } from './messages';
import { beforeDispatchAITransaction } from './action-utils';
import { SuggestTitleEvents } from '../../utils/confluence-suggest-title/event-enums';
function isSelectionAtParagraphStart($pos) {
  const node = $pos.parent;
  return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
}
function isFragmentSingleParagraph(fragment) {
  return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
}
function isSelectionInTaskOrDecisionNode($pos) {
  const node = $pos.parent;
  return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
}

// TODO POSTEAP
// Revisit how we create actions and pass formatMessage
export const createInsertAtTop = ({
  appearance
}) => ({
  formatMessage
}) => ({
  title: formatMessage(messages.insertAtTop),
  analyticsTitle: messages.insertAtTop.defaultMessage,
  appearance,
  run({
    editorView,
    pmFragment
  }) {
    const transaction = editorView.state.tr;
    const slice = new Slice(pmFragment, 0, 0);
    transaction.replace(0, 0, slice);
    beforeDispatchAITransaction(transaction);
    editorView.dispatch(transaction);
  }
});

// TODO POSTEAP
// Revisit how we create actions and pass formatMessage
export const createInsertBelow = ({
  appearance
}) => ({
  formatMessage
}) => ({
  title: formatMessage(messages.insertBelow),
  appearance,
  analyticsTitle: messages.insertBelow.defaultMessage,
  run({
    editorView,
    positions,
    pmFragment
  }) {
    const transaction = editorView.state.tr;
    const insertPos = editorView.state.doc.resolve(positions[1]).after();
    safeInsert(pmFragment, insertPos)(transaction);
    beforeDispatchAITransaction(transaction);
    editorView.dispatch(transaction);
  }
});

// TODO POSTEAP
// Revisit how we create actions and pass formatMessage
export const createInsertAtCurrentPosition = ({
  appearance
}) => ({
  formatMessage
}) => ({
  title: formatMessage(messages.insert),
  analyticsTitle: messages.insert.defaultMessage,
  appearance,
  run({
    editorView,
    positions,
    pmFragment
  }) {
    const {
      state
    } = editorView;
    const transaction = state.tr;
    const pos = positions[0];
    const $pos = state.doc.resolve(pos);
    const isParagraphStart = isSelectionAtParagraphStart($pos);
    // if selection is at the beginning of paragraph,
    // insert before the cursor so that it inserts without an extra new line
    const insertPos = isParagraphStart ? pos - 1 : pos;

    // if selection is inside decision or task node AND pmFragment is a single paragraph
    // strip the paragraph so it can insert inside the decision/task
    let fragmentToInsert = pmFragment;
    if (isSelectionInTaskOrDecisionNode($pos) && isFragmentSingleParagraph(pmFragment)) {
      fragmentToInsert = pmFragment.firstChild.content;
    }
    transaction.insert(insertPos, fragmentToInsert);
    beforeDispatchAITransaction(transaction);
    editorView.dispatch(transaction);
  }
});
function getLastContentDepth({
  pmFragment
}) {
  let depth = 0;
  let currentNode = pmFragment;
  while (currentNode.firstChild) {
    depth++;
    currentNode = currentNode.firstChild;
  }
  return depth;
}

// TODO POSTEAP
// Revisit how we create actions and pass formatMessage
export const createReplace = ({
  appearance
}) => ({
  formatMessage
}) => ({
  title: formatMessage(messages.replace),
  appearance,
  analyticsTitle: messages.replace.defaultMessage,
  run({
    editorView,
    positions,
    pmFragment
  }) {
    const transaction = editorView.state.tr;
    const endPositionDepth = editorView.state.doc.resolve(positions[1]).depth;
    const lastFragmentDepth = getLastContentDepth({
      pmFragment
    });
    const sliceOpenEnd = Math.min(endPositionDepth, lastFragmentDepth);
    const slice = new Slice(pmFragment, 1, sliceOpenEnd);

    // We check if the positions are the same if so we replace the whole document
    // This is a quick spike so real implementation might need to be different
    // You might need to create a new replace action
    if (positions[0] === positions[1]) {
      transaction.replaceRange(0, editorView.state.doc.content.size, slice);
    } else {
      try {
        transaction.replaceRange(positions[0], positions[1], slice);
        // If you can't replace the range, use safeInsert
      } catch {
        safeInsert(pmFragment, undefined, true)(transaction);
        const tr = addAnalytics({
          editorState: editorView.state,
          tr: editorView.state.tr,
          payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'proseMirrorReplace',
            eventType: 'operational',
            attributes: {}
          }
        });
        editorView.dispatch(tr);
      }
    }
    beforeDispatchAITransaction(transaction);
    editorView.dispatch(transaction);
  }
});

/**
 * EXPERIMENTAL: Util for experimental flow where 'Suggest title' in
 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
 * This util allows replacing the title in Confluence.
 */
export const createReplaceExistingConfluenceTitle = ({
  appearance
}) => ({
  formatMessage
}) => ({
  title: formatMessage(messages.replaceTitle),
  analyticsTitle: messages.replaceTitle.defaultMessage,
  appearance,
  run({
    pmFragment
  }) {
    let fragmentToInsert = pmFragment;
    let textContent = '';
    fragmentToInsert.forEach(node => {
      textContent += node.textContent;
    });
    const confluenceTitle = document.querySelector('textarea[data-test-id="editor-title"]');
    if (confluenceTitle) {
      const event = new CustomEvent(SuggestTitleEvents.ReplaceConfluenceTitle, {
        detail: {
          title: textContent
        }
      });
      document.dispatchEvent(event);
      confluenceTitle.scrollIntoView();
    }
  }
});